"use client";

import { cn } from "@/lib/utils";

// Carte d'option QCM. `multi` => carré (checkbox), sinon rond (radio).
export function OptionCard({
  label,
  selected,
  multi = false,
  onClick,
}: {
  label: string;
  selected: boolean;
  multi?: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="option"
      className={cn(
        "flex w-full items-center gap-3 rounded-2xl border px-4 py-4 text-left text-[15px] font-medium transition active:scale-[0.99]",
        selected
          ? "border-indigo-400 bg-indigo-500/15 text-white"
          : "border-white/12 bg-white/[0.04] text-neutral-100 hover:border-white/30"
      )}
    >
      <span
        className={cn(
          "grid h-5 w-5 shrink-0 place-items-center border transition",
          multi ? "rounded-md" : "rounded-full",
          selected ? "border-indigo-400 bg-indigo-500" : "border-white/30"
        )}
      >
        {selected && (
          <span
            className={cn(
              "bg-white",
              multi ? "h-2.5 w-2.5 rounded-[3px]" : "h-2 w-2 rounded-full"
            )}
          />
        )}
      </span>
      <span>{label}</span>
    </button>
  );
}
